/**
 * Trending Destinations API Service
 * Handles fetching trending destinations for homepage with geo-localization
 */

import { getUserCountry, getCurrencyForCountry } from '../utils/userLocation.js'

export class TrendingService {
  constructor(apiClient, handleApiError) {
    this.apiClient = apiClient;
    this.handleApiError = handleApiError;
  }

  /**
   * Get trending destinations with automatic geo-localization
   * Works globally - detects user location and currency automatically
   *
   * @param {Object} params - Query parameters
   * @param {string} params.search_scope - 'local' or 'international'
   * @param {string} [params.user_country] - User's country code (auto-detected if not provided)
   * @param {number} [params.limit=4] - Number of results
   * @param {string} [params.currency] - Currency code (auto-detected if not provided)
   * @returns {Promise<Object>} Trending destinations response
   */
  async getTrendingDestinations({
    search_scope,
    user_country = null,
    limit = 4,
    currency = null
  }) {
    try {
      // Use provided values or fall back to detection (without auth store here - caller should pass correct values)
      const detectedCountry = user_country || getUserCountry()
      const detectedCurrency = currency || getCurrencyForCountry(detectedCountry)

      const response = await this.apiClient.get('/trending/destinations', {
        params: {
          search_scope,
          user_country: detectedCountry,
          limit,
          currency: detectedCurrency
        }
      });

      return response.data;
    } catch (error) {
      this.handleApiError(error, 'Failed to fetch trending destinations');
      throw error;
    }
  }
}
